module.exports = __webpack_public_path__ + "img/boilerplate-commission@3x.a66d1c0b.png";